<template>
  <AppTableControl
    @search-clicked="beginSearch"
    @query-debounced="searchByName"
    @export-excel-clicked="downloadReport(1)"
    @export-pdf-clicked="downloadReport(2)"
  >
    <template #filters>
      <div class="d-flex">
        <b-form-group label="Type">
          <b-form-select
            v-model="selectedType"
            :options="monthlySelections"
            @input="
              $store.dispatch('changeSchoolStaffMonthlyDateType', {
                type: $event,
              })
            "
          ></b-form-select>
        </b-form-group>

        <!-- begin:: specific date -->
        <b-form-group v-if="selectedType === 1">
          <AppFieldDateSelector
            :date-value="engageDate"
            no-search
            @clickedSearch="filterDate"
            @fetched-date="filterDate"
            @select-date="formatSpecificDate"
          >
          </AppFieldDateSelector
        ></b-form-group>
        <!-- end:: specific date -->

        <!-- begin:: date range -->
        <b-form-group class="ml-4" label="From Date" v-if="selectedType === 2">
          <DatePicker v-model="dateRange[0]" />
        </b-form-group>

        <b-form-group class="ml-4" label="To Date" v-if="selectedType === 2">
          <DatePicker v-model="dateRange[1]" />
        </b-form-group>
        <!-- end:: date range -->
      </div>
    </template>
  </AppTableControl>
</template>

<script>
import dayjs from "dayjs";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import AppTableControl from "@/modules/core/components/shared/filter/AppTableControl";
import AppFieldDateSelector from "@/modules/core/components/utility/date/AppFieldDateSelector";
import objectSupport from "dayjs/plugin/objectSupport";

export default {
  name: "StaffMonthlyAttendanceTableControl",
  components: { AppFieldDateSelector, AppTableControl, DatePicker },
  data() {
    return {
      type: 1,
      selectedType: 1,
      monthlySelections: [
        { value: 1, text: "Specific" },
        { value: 2, text: "Range" },
      ],
      dateRange: [dayjs().toDate(), dayjs().toDate()],
      specificDate: dayjs(),
      engageDate: false,
    };
  },
  beforeDestroy() {
    console.log("Resetting Monthly Filters");

    // Date month filter
    this.$store.dispatch("changeSchoolStaffMonthlyAttendanceDate", {
      date: dayjs().format(),
    });

    // From and To Date filters
    this.$store.dispatch("changeSchoolStaffMonthlyRangeFilters", {
      from_date: dayjs().toDate(),
      to_date: dayjs().toDate(),
    });

    // Base (name) filter
    this.$store.dispatch("changeSchoolStaffMonthlyNameFilter", {
      name: null,
    });
  },
  methods: {
    /**
     * Search by name query.
     *
     * @param nameQuery
     */
    searchByName(nameQuery) {
      console.log(nameQuery);

      this.$store.dispatch("changeSchoolStaffMonthlyNameFilter", {
        name: nameQuery,
      });

      if (this.selectedType === 1)
        this.$store.dispatch("fetchSchoolStaffMonthlyAttendance");
      else if (this.selectedType === 2)
        this.$store.dispatch("fetchSchoolStaffMonthlyRangeAttendance");
    },
    /**
     * Format date
     * @param date
     */
    formatSpecificDate(date) {
      console.log("Formatting specific date");
      dayjs.extend(objectSupport);

      this.specificDate = dayjs({
        year: date.year,
        month: date.month,
      });
    },

    /**
     * @param data (year & month)
     */
    filterDate(data) {
      console.log("Date ", data);
      const objectSupport = require("dayjs/plugin/objectSupport");
      dayjs.extend(objectSupport);

      const date = dayjs({
        year: data.year,
        month: data.month,
      });

      this.$store.dispatch("changeSchoolStaffMonthlyAttendanceDate", {
        date: date.format(),
      });

      this.$store.dispatch("fetchSchoolStaffMonthlyAttendance");
    },

    /**
     * Download.
     * @param type
     */
    async downloadReport(type) {
      try {
        this.$bvToast.toast("Downloading Report . . .", {
          variant: "primary",
        });
        if (this.selectedType === 1)
          await this.$store.dispatch("changeSchoolStaffMonthlyAttendanceDate", {
            date: this.specificDate.format(),
          });
        else this.changeRange();

        const response = await this.$store.dispatch(
          "downloadStaffMonthlyAttendanceReport",
          { type }
        );

        console.log(response);
        console.log("Successfully downloaded report of type : ", type);

        this.$bvToast.toast("Successfully downloaded report . . .", {
          variant: "primary",
        });
      } catch (e) {
        console.error(e);

        await this.$bvModal.msgBoxOk("Error", {
          okVariant: "danger",
        });
      }
    },

    /**
     * Begin Search.
     */
    beginSearch() {
      console.log("Begin search");

      if (this.selectedType === 1) this.engageDate = !this.engageDate;
      else if (this.selectedType === 2) {
        this.changeRange();
        this.$store.dispatch("fetchSchoolStaffMonthlyRangeAttendance");
      }
    },

    changeRange() {
      console.log("Date range type search.");

      const queries = {
        from_date: this.dateRange[0],
        to_date: this.dateRange[1],
      };

      this.$store.dispatch("changeSchoolStaffMonthlyRangeFilters", queries);
    },
  },
};
</script>

<style scoped></style>
